import React, { createContext } from 'react';
import type { TDragging, TPlaceholder, TItem, TPickOffset } from './types';

interface IGridContextAtrr {
  dragging: TDragging;
  updateDragging: (d: TDragging) => void;
  placeholder: TPlaceholder;
  updatePlaceholder: (ph: TPlaceholder) => void;
  pickItem: TItem | null;
  updatePickItem: (pi: TItem | null) => void;
  pickOffset: TPickOffset;
  updatePickOffset: (po: TPickOffset) => void;

  _SX_: null | number;
  _SY_: null | number;
}

export const GridContext = createContext<IGridContextAtrr>({
  dragging: null,
  updateDragging: () => {},
  placeholder: null,
  updatePlaceholder: () => {},
  pickItem: null,
  updatePickItem: () => {},
  pickOffset: null,
  updatePickOffset: () => {},
  _SX_: null,
  _SY_: null,
});

class GridRoot extends React.Component<{
  _SX_?: number | null;
  _SY_?: number | null;
}> {
  state = {
    dragging: null,
    placeholder: null,
    pickItem: null,
    pickOffset: null,
  };

  updateDragging = (dragging: TDragging) => {
    this.setState({
      dragging,
    });
  };

  updatePlaceholder = (placeholder: TPlaceholder) => {
    this.setState({
      placeholder,
    });
  };

  updatePickItem = (pickItem: TItem | null) => {
    this.setState({
      pickItem,
    });
  };

  updatePickOffset = (pickOffset: TPickOffset) => {
    this.setState({
      pickOffset,
    });
  };

  render() {
    const { children, _SX_ = null, _SY_ = null } = this.props;
    const { dragging, placeholder, pickItem, pickOffset } = this.state;
    const updateDragging = this.updateDragging;
    const updatePlaceholder = this.updatePlaceholder;
    const updatePickItem = this.updatePickItem;
    const updatePickOffset = this.updatePickOffset;
    return (
      <GridContext.Provider
        value={{
          dragging,
          updateDragging,
          placeholder,
          updatePlaceholder,
          pickItem,
          updatePickItem,
          pickOffset,
          updatePickOffset,
          _SX_,
          _SY_,
        }}
      >
        {children}
      </GridContext.Provider>
    );
  }
}

export default GridRoot;
